<app-onboarding-base-modal
  [heading]="heading"
  [bodyPrimary]="message"
  [pointerSide]="pointerSide"
  [pointerOffset]="pointerOffset"
  [primaryLabel]="primaryLabel"
  [secondaryLabel]="secondaryLabel"
  secondaryStyle="pill"
  textDensity="compact"
  headingAlign="left"
  (dismissed)="onDismiss()"
  (primaryAction)="onPrimary()"
  (secondaryAction)="onSecondary()"
></app-onboarding-base-modal>
